import { Flags, getIconByValue } from "./components/Flags/Flags";
import { IShipmentAvailableQuotes, OrderShipmentFieldsType } from "./interfaces";

export const IS_BUNDLE_VIEW = "bundleView";
export const IS_AUTO_PRINT = "autoPrint";
export const SHIPMENTS_TAB = "shipmentsTab";
export const SEARCH_TEXT = "searchText";
export const AUTHENTICATED_EMPLOYEE_JWT = "authenticatedEmployee";
export const API_HEADERS = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${window.localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT)}`,
};

const STAGING_ENV = "api-egtrade-staging.com";
const PROD_ENV = "api-egtrade.com";
// TODO: Get env details from JWT token instead of window location
const hostname = window && window.location && window.location.hostname;

let ORDER_SHIPMENTS_BASE_URL: string;
const orderShipmentsConfigUrls = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-order-shipments/api/v1",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-order-shipments/api/v1",
};
// Default to staging if hostname doesn't match
ORDER_SHIPMENTS_BASE_URL =
  orderShipmentsConfigUrls[hostname] || "https://api-egtrade-staging.com/egtrade-api-order-shipments/api/v1";

export { ORDER_SHIPMENTS_BASE_URL };

//URL for custom package

let CUSTOM_PACKAGE_BASE_URL: string;
const customPackageConfigUrl = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-shipments-v2/api/v1/consignments",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments",
};
// Default to staging if hostname doesn't match
CUSTOM_PACKAGE_BASE_URL =
  customPackageConfigUrl[hostname] || "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments";

export { CUSTOM_PACKAGE_BASE_URL };

//GetQuote base URL

let GET_QUOTE_BASE_URL: string;
const getQuotebaseConfigUrl = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-shipments-v2/api/v1/consignments",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments",
};
// Default to staging if hostname doesn't match
GET_QUOTE_BASE_URL =
  getQuotebaseConfigUrl[hostname] || "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments";

export { GET_QUOTE_BASE_URL };

//getSku base URL

let GET_SKU: string;
const getSKUConfig = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-aggregator/ca/v1",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-aggregator/ca/v1",
};
// Default to staging if hostname doesn't match
GET_SKU = getSKUConfig[hostname] || "https://api-egtrade.com/egtrade-api-aggregator/ca/v1";

export { GET_SKU };

//CreateShipment Base URL

let CREATE_SHIPMENT_BASE_URL: string;
const createShipmentbaseConfigUrl = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-shipments-v2/api/v1/consignments",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments",
};
// Default to staging if hostname doesn't match
CREATE_SHIPMENT_BASE_URL =
  createShipmentbaseConfigUrl[hostname] || "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1/consignments";

export { CREATE_SHIPMENT_BASE_URL };

//AmazonRefresh Base URL

let AMAZON_REFRESH_BASE_URL: string;
const amazonRefreshBaseConfigUrl = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-parse-orders",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-parse-orders",
};
// Default to staging if hostname doesn't match
AMAZON_REFRESH_BASE_URL = amazonRefreshBaseConfigUrl[hostname] || "https://api-egtrade-staging.com/egtrade-parse-orders";

export { AMAZON_REFRESH_BASE_URL };

let SHIPMENTS_V2_BASE_URL: string;
const shipmentsV2ConfigUrls = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-shipments-v2/api/v1",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1",
};
// Default to staging if hostname doesn't match
SHIPMENTS_V2_BASE_URL = shipmentsV2ConfigUrls[hostname] || "https://api-egtrade-staging.com/egtrade-api-shipments-v2/api/v1";

export { SHIPMENTS_V2_BASE_URL };

const CA_ORDER_BASE_URL = "https://complete.channeladvisor.com/Orders/OrderDetailV2.mvc?apid=12036969&invoiceId=";

export { CA_ORDER_BASE_URL };

export const Operators = {
  EQ: "eq",
  NE: "ne",
  IN: "in",
  NIN: "nin",
  CONTAINS: "contains",
  NOT_CONTAINS: "not_contains",
  GT: "gt",
  GTE: "gte",
  LT: "lt",
  LTE: "lte",
} as const;

export type Operator = (typeof Operators)[keyof typeof Operators];

export interface Filter {
  field: string;
  operator: Operator;
  value: string | string[] | number | number[] | boolean | Date;
}

export interface sortOptions {
  direction?: string;
  field?: string;
}

export enum DataType {
  TEXT,
  NUMBER,
  DATE,
  BOOLEAN,
  DOUBLE,
}

export const orderShipmentFields: OrderShipmentFieldsType[] = [
  {
    fieldName: "pickingDetail.packingStationId",
    businessFieldName: "Packing Station",
    operatorsAllowed: ["in", "nin"],
    presetValues: ["P1", "P2", "M"],
    fieldDataType: DataType.TEXT,
    enableForSort: false,
  },
  // {
  //   fieldName: "orderIds",
  //   businessFieldName: "Order ID",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.NUMBER,
  // },
  {
    fieldName: "siteName",
    businessFieldName: "Site Name",
    operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
    fieldDataType: DataType.TEXT,
    enableForSort: false,
  },
  // {
  //   fieldName: "siteOrderID",
  //   businessFieldName: "Site Order ID",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "privateNotes",
  //   businessFieldName: "Private Notes",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "specialInstructions",
  //   businessFieldName: "Special Instructions",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "totalPrice",
  //   businessFieldName: "Total Price",
  //   operatorsAllowed: ["eq", "ne", "gt", "gte", "lt", "lte"],
  //   fieldDataType: DataType.DOUBLE,
  // },
  // {
  //   fieldName: "requestedShippingCarrier",
  //   businessFieldName: "Shipping Carrier",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  {
    fieldName: "requestedShippingClass",
    businessFieldName: "Shipping Class",
    operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
    presetValues: ["Click & Collect"],
    fieldDataType: DataType.TEXT,
  },
  // {
  //   fieldName: "checkoutStatus",
  //   businessFieldName: "Checkout Status",
  //   operatorsAllowed: ["eq", "ne", "in", "nin"],
  //   presetValues: ["Completed"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "paymentStatus",
  //   businessFieldName: "Payment Status",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   presetValues: ["Cleared"],
  //   fieldDataType: DataType.TEXT,
  // },
  {
    fieldName: "appImportDateTime",
    businessFieldName: "App Import Date Time",
    operatorsAllowed: ["gt", "gte", "lt", "lte", "eq", "ne"],
    fieldDataType: DataType.DATE,
    enableForSort: true,
  },
  {
    fieldName: "shippingStatus",
    businessFieldName: "Shipping Status",
    operatorsAllowed: ["eq", "ne", "in", "nin"],
    presetValues: ["Shipped", "Unshipped", "ReadyToPrint", "Error", "PickAndPack", "Cancelled"],
    fieldDataType: DataType.TEXT,
  },
  {
    fieldName: "pickingStatus",
    businessFieldName: "Picking Status",
    operatorsAllowed: ["eq", "ne", "in", "nin"],
    presetValues: ["Picked", "Unpicked"],
    fieldDataType: DataType.TEXT,
  },
  {
    fieldName: "issueStatus",
    businessFieldName: "Issue Status",
    operatorsAllowed: ["eq", "ne", "in", "nin"],
    presetValues: ["Issue", "NoIssue"],
    fieldDataType: DataType.TEXT,
  },
  {
    fieldName: "userId",
    businessFieldName: "User Id",
    operatorsAllowed: ["ne"],
    fieldDataType: DataType.TEXT,
  },
  {
    fieldName: "flagType",
    businessFieldName: "Flag",
    operatorsAllowed: ["eq", "ne", "in", "nin"],
    presetValues: Flags().map((flag) => flag?.value),
    presetFlagIcon: Flags().map((flag) => flag?.icon),
    businessIconName: Flags().map((flag) => flag?.text),
  },

  // {
  //   fieldName: "duplicateFlag",
  //   businessFieldName: "Duplicate Flag",
  //   operatorsAllowed: ["eq", "ne"],
  //   presetValues: [0, 1],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "buyerUserId",
  //   businessFieldName: "Buyer User ID",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "buyerEmailAddress",
  //   businessFieldName: "Buyer Email Address",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingFirstName",
  //   businessFieldName: "Shipping First Name",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingDaytimePhone",
  //   businessFieldName: "Shipping Phone Number",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingAddressLine1",
  //   businessFieldName: "Shipping Address Line 1",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingAddressLine2",
  //   businessFieldName: "Shipping Address Line 2",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingCity",
  //   businessFieldName: "Shipping City",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingStateOrProvinceName",
  //   businessFieldName: "Shipping State",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingPostalCode",
  //   businessFieldName: "Shipping Post Code",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shippingCountry",
  //   businessFieldName: "Shipping Country",
  //   operatorsAllowed: ["eq", "ne", "in", "nin"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "items.sku",
  //   businessFieldName: "Sku",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "items.title",
  //   businessFieldName: "Title",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "items.quantity",
  //   businessFieldName: "Quantity",
  //   operatorsAllowed: ["eq", "ne", "gt", "gte", "lt", "lte"],
  //   fieldDataType: DataType.DOUBLE,
  // },
  // {
  //   fieldName: "items.unitPrice",
  //   businessFieldName: "Unit Price",
  //   operatorsAllowed: ["eq", "ne", "gt", "gte", "lt", "lte"],
  //   fieldDataType: DataType.DOUBLE,
  // },
  // {
  //   fieldName: "items.unitEstimatedShippingCost",
  //   businessFieldName: "Unit Est Shipping Cost",
  //   operatorsAllowed: ["eq", "ne", "gt", "gte", "lt", "lte"],
  //   fieldDataType: DataType.DOUBLE,
  // },
  // {
  //   fieldName: "items.warehouseLocation",
  //   businessFieldName: "Warehouse Location",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "items.barcode",
  //   businessFieldName: "Barcode",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "items.varyingAttributes",
  //   businessFieldName: "Varying Attributes",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "historyList.userId",
  //   businessFieldName: "Logs User ID",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "historyList.action",
  //   businessFieldName: "Logs Action Message",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "historyList.actionTimestamp",
  //   businessFieldName: "Logs Time Stamp",
  //   operatorsAllowed: ["eq", "ne", "gt", "gte", "lt", "lte"],
  //   fieldDataType: DataType.DATE,
  // },
  // {
  //   fieldName: "shipmentDetails.shippedItems.itemTrackingId",
  //   businessFieldName: "Tracking Number",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shipmentDetails.shippingCost",
  //   businessFieldName: "Shipment Cost",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shipmentDetails.shipmentId",
  //   businessFieldName: "Shipment ID",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "shipmentDetails.courierName",
  //   businessFieldName: "Courier Name",
  //   operatorsAllowed: ["eq", "ne", "in", "nin", "contains", "not_contains"],
  //   fieldDataType: DataType.TEXT,
  // },
  // {
  //   fieldName: "pickingStatusDatetime",
  //   businessFieldName: "Picking Date Time",
  //   operatorsAllowed: ["gt", "gte", "lt", "lte", "eq", "ne"],
  //   fieldDataType: DataType.DATE,
  // },
  // {
  //   fieldName: "shippingStatusDatetime",
  //   businessFieldName: "Shipment Date Time",
  //   operatorsAllowed: ["gt", "gte", "lt", "lte", "eq", "ne"],
  //   fieldDataType: DataType.DATE,
  // },
  // {
  //   fieldName: "notifyChannelAdvisor",
  //   businessFieldName: "Notify Channel Advisor",
  //   operatorsAllowed: ["eq"],
  //   presetValues: ["True", "False"],
  //   fieldDataType: DataType.BOOLEAN,
  // },
];

export const ORDER_SHIPMENT_SEARCH_OPTIONS_LS = "ORDER_SHIPMENT_SEARCH_OPTIONS";
export const ORDERS_SEARCH_OPTIONS_LS = "ORDERS_SEARCH_OPTIONS";

export const ORDER_SHIPMENTS_SEARCH_TYPES = {
  //ADVANCED_SEARCH: "Advanced Search",
  PRODUCT: "Product",
  BARCODE: "Barcode",
  ORDERID: "Order ID",
  CUSTOMER: "Customer",
  SHIPMENT: "Shipment",
};

export const WEBSOCKET_URL = "ws://localhost:9000";
export const WEBSOCKET_CONNECTED_KEY = "websocketConnected";
export const PAGINATION_PAGE_COUNT_OPTIONS = [10, 20, 50, 100];

export const UPDATE_TRACKING_ALLOWED_IDS = ["INH4", "INH5", "INH6", "INH7", "INH8", "INH9", "INH10"];

export const SHIPMENT_AVAILABLE_QUOTES: IShipmentAvailableQuotes[] = [
  {
    availableQuotes: {
      EPARCEL: {
        items: [
          {
            reference: "EG819-13",
            quantity: "1",
            weight: "0.5",
            length: "10.0",
            width: "10.0",
            height: "10.0",
          },
        ],
        carrierQuotes: [
          {
            productId: "3D85",
            parcelType: "PARCEL POST + SIGNATURE",
            price: 10.579999923706055,
            reference: "EG819-13",
          },
          {
            productId: "3J85",
            parcelType: "EXPRESS POST + SIGNATURE",
            price: 14.829999923706055,
            reference: "EG819-13",
          },
        ],
      },
      INHOUSE: {
        items: [
          {
            reference: "EG819-13",
            quantity: "1",
            weight: "0.1",
            length: "32.0",
            width: "2.0",
            height: "23.0",
          },
        ],
        carrierQuotes: [
          {
            productId: "INH5",
            parcelType: "Green large C4 Size",
            price: 5.5,
            shippingClass: "Standard",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: true,
            envFlag: true,
          },
          {
            productId: "INH8",
            parcelType: "500g satchel with tracking",
            price: 7.599999904632568,
            shippingClass: "Standard",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: true,
            envFlag: false,
          },
          {
            productId: "INH7",
            parcelType: "Large Envelope (B4 size) Express",
            price: 8,
            shippingClass: "Express",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: true,
            envFlag: true,
          },
          {
            productId: "INH9",
            parcelType: "500g express with tracking",
            price: 13,
            shippingClass: "Express",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: true,
            envFlag: false,
          },
          {
            productId: "INH2",
            parcelType: "Large letter",
            price: 2.200000047683716,
            shippingClass: "Standard",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: false,
            envFlag: true,
          },
          {
            productId: "INH10",
            parcelType: "Red large C4 Size",
            price: 5.5,
            shippingClass: "Standard",
            weight: 0.10000000149011612,
            reference: "EG819-13",
            trackingAvailable: true,
            envFlag: true,
          },
        ],
      },
      DIRECTFREIGHT: {
        items: [
          {
            reference: "EG819-13",
            quantity: "1",
            weight: "0.1",
            length: "32.0",
            width: "2.0",
            height: "23.0",
          },
        ],
        carrierQuotes: [
          {
            productId: "DF1",
            parcelType: "Direct Frieght",
            price: 19.06410026550293,
          },
        ],
      },
      MYFASTWAY: {
        items: [
          {
            reference: "EG819-13",
            quantity: "1",
            weight: "0.3",
            length: "10.0",
            width: "10.0",
            height: "10.0",
          },
        ],
        carrierQuotes: [
          {
            productId: "Labels",
            parcelType: "EG819-13: 300GM satchel",
            price: 4.894999980926514,
            reference: "EG819-13",
          },
          {
            productId: "Service",
            parcelType: "Fuel Surcharge",
            price: 0.4405499994754791,
          },
          {
            productId: "Service",
            parcelType: "If address is unattended, parcel will be left in a safe place where available",
            price: 0,
          },
        ],
      },
    },
  },
];

export const CUSTOM_PACKAGE_DATA = [
  {
    packageName: "Under 500g",
    quantity: 1,
    weight: 0.5,
    length: 10,
    width: 10,
    height: 10,
  },
  {
    packageName: "Under 1kg",
    quantity: 1,
    weight: 1.0,
    length: 10,
    width: 10,
    height: 10,
  },
  {
    packageName: "Under 2kg",
    quantity: 1,
    weight: 2.0,
    length: 10,
    width: 10,
    height: 10,
  },
  {
    packageName: "Under 300g",
    quantity: 1,
    weight: 0.3,
    length: 10,
    width: 2,
    height: 10,
  },
  {
    packageName: "Custom Packaging",
    quantity: 1,
    weight: 0.5,
    length: 10,
    width: 10,
    height: 10,
  },
];

export const READY_TO_DISPATCH_STATUS = "READY_TO_DISPATCH";
export const SHIPPED_STATUS = "Shipped";
export const TRIGGER_SELECT_QUOTE = "TRIGGER_SELECT_QUOTE";
export const DELETE_SELECTED_QUOTE = "DELETE_SELECTED_QUOTE";
export const PICK_AND_PACK_STATUS = "PickAndPack";

export const ACTIVE_ORDERS_TABLE_TAB_KEY = "ACTIVE_ORDERS_TABLE_TAB_KEY";
export const ORDERS_TABLE_TABS = {
  UN_PICKED: { value: "UN_PICKED", label: "Unpicked" },
  ASSIGNED: { value: "ASSIGNED", label: "Assigned" },
  ERROR: { value: "ERROR", label: "Error" },
  ISSUES: { value: "ISSUES", label: "Issues" },
  ON_HOLD: { value: "ON_HOLD", label: "On Hold" },
  CANCELLED: { value: "CANCELLED", label: "Cancelled" },
};

export const SHIPMENTS_TABLE_TABS = {
  ALL_PICKED_ORDERS: { value: "ALL_PICKED_ORDERS", label: "All Picked Orders" },
  ERROR: { value: "ERROR", label: "Error" },
  CLICK_AND_COLLECT: { value: "CLICK_AND_COLLECT", label: "Click and Collect" },
  PICK_AND_PACK: { value: "PICK_AND_PACK", label: "Pick and Pack" },
  SHIPPED: { value: "SHIPPED", label: "Shipped" },
  ALL_ORDERS: { value: "ALL_ORDERS", label: "All Orders" },
  PRINT_HUB: { value: "PRINT_HUB", label: "Print Hub" },
};
